module.exports = __webpack_public_path__ + "static/media/fabio_test.11324726.jpg";